export interface SurplusLinesRegistration {
    FirstName: string,
    LastName: string,
    Email: string,
    Phone: string,
    Password: string,
    Token: string,
    OpportunityRole: string

}

export class SurplusLinesRegistrationModel implements SurplusLinesRegistration {
    FirstName: string = '';
    LastName: string = '';
    Email: string = '';
    Phone: string = '';
    Password: string = '';
    Token: string = '';
    OpportunityRole: string = '';
}